import {createContext, ReactNode, useContext, useState} from 'react'
import {createTheme, ThemeProvider as MuiThemeProvider} from '@mui/material'
import {deDE as dataGridDeDE} from '@mui/x-data-grid';
import {deDE as coreDeDE} from '@mui/material/locale';
import {deDE} from '@mui/x-date-pickers/locales';
import portalTheme from "./themes/PortalTheme";
import testamentTheme from "./themes/TestamentTheme";


interface ThemeContextType {
    themeMode: string
    setTheme: (theme: string) => void
}

const ThemeContext = createContext<ThemeContextType>({} as ThemeContextType)
const useThemeContext = () => useContext(ThemeContext)
interface Props {
    children: ReactNode
}

const SosThemeProvider = (props: Props) => {
    const [themeMode, setThemeMode] = useState("portal");


    function setTheme(theme: string) {
        let themename = "portal";
        if (theme === "start" || theme === "info" || theme === "uaa") {
            themename = "testament"
        }
        setThemeMode(themename)
        //  localStorage.setItem("theme", JSON.stringify(theme));
    }

    function getTheme(themeMode: string) {
        if (themeMode === 'testament') {
            return createTheme(testamentTheme, deDE, dataGridDeDE, coreDeDE)
        } else {
            return createTheme(portalTheme, deDE, dataGridDeDE, coreDeDE, {
                typography: {
                    "fontFamily": `"HelveticaNeueLTStd-Bd", Helvetica, Arial, sans-serif`
                }
            });
        }
    }


    return (
        <ThemeContext.Provider value={{themeMode, setTheme}}>
            <MuiThemeProvider theme={getTheme(themeMode)}>
                {props.children}
            </MuiThemeProvider>
        </ThemeContext.Provider>
    )
}



export {
    useThemeContext,
    SosThemeProvider
}